module.exports = __webpack_public_path__ + "static/img/y43.1acdd0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y43.jpg
// module id = snCA
// module chunks = 1